import React, { useState, useCallback, useMemo } from 'react';
import FolderTree from '../FolderTree';
import { folderId2String } from '@web-mail/util';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import useState2RM from '@web-mail/hooks/useState2ReduxMock';
import { useActions, useAppDispatch, MailActions, useAppSelector } from '@web-common/state/createStore';
import { actions as mailTabActions, tabType } from '@web-common/state/reducer/mailTabReducer';
import debounce from 'lodash/debounce';
import { Menu } from 'antd';
import styles from './allFolder.module.scss';
import { TongyongQueren } from '@sirius/icons';
import { parseAccountFromAllFolderSubAccount, folderIdIsAllFolder, mailLogicStateIsMerge, folderIdIsAllSentFolder, folderIdIsAllDraftFolder } from '@web-mail/util';
import { Thunks } from '@web-common/state/reducer/mailReducer';
import { FLOLDER } from '@web-mail/common/constant';
import { apiHolder as api, getIn18Text, apis } from 'api';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
import useStateRef from '@web-mail/hooks/useStateRef';
import { isFollowFolder, isCustomerUnFollowFolder, parseAllFolderSubAccount, isAllFollowFolder, isUnFollowFolder } from '@web-mail/util';
const systemApi = api.api.getSystemApi();
const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
const accountApi = api.api.requireLogicalApi(apis.accountApiImpl);
const AllFolder = props => {
    const { storeFolderSortInfo, setStoreFolderSortInfo, data, handleFodlerVisiableChange } = props;
    const dataRef = useStateRef(data);
    const [folderTreeDragModel] = useState2RM('folderTreeDragModel');
    const [isDragModel] = useState2RM('isDragModel');
    const [mailAccountAliasMap] = useState2RM('mailAccountAliasMap');
    const currentTabType = useAppSelector(state => state.mailTabReducer.currentTab.type);
    const curTabIsReadTab = useMemo(() => currentTabType === tabType.read, [currentTabType]);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState2RM('selectedKeys', 'doUpdateSelectedKey');
    const isSearching = useAppSelector(state => !!state.mailReducer.mailSearching);
    const isMerge = () => mailLogicStateIsMerge(selectedKeys.id, selectedKeys.accountId, isSearching);
    const dispatch = useAppDispatch();
    const reducer = useActions(MailActions);
    const localData = useMemo(() => {
        if (storeFolderSortInfo && storeFolderSortInfo.length > 0 && data && data.length > 0) {
            let res = [];
            let keyMap = {};
            storeFolderSortInfo.forEach(item => {
                const id = item.id;
                const resData = data.find(item => item.entry.mailBoxId == id);
                if (resData) {
                    if ((item === null || item === void 0 ? void 0 : item.show) || item.id == FLOLDER.ALL_RECEIVE) {
                        res.push(resData);
                    }
                    keyMap[id] = 1;
                }
            });
            res = res.map(item => {
                var _a;
                if ((_a = item.children) === null || _a === void 0 ? void 0 : _a.length) {
                    const _list = item.children.map(child => {
                        var _a;
                        const accountName = parseAccountFromAllFolderSubAccount(child.entry.mailBoxId);
                        const aliseName = mailAccountAliasMap[((_a = systemApi.getCurrentUser(accountName)) === null || _a === void 0 ? void 0 : _a.agentEmail) || accountName] || child.entry.mailBoxName;
                        if (accountName) {
                            return Object.assign(Object.assign({}, child), { entry: Object.assign(Object.assign({}, (child.entry || {})), { mailBoxName: aliseName }) });
                        }
                    });
                    return Object.assign(Object.assign({}, item), { children: _list });
                }
                return item;
            });
            return res;
        }
        return data;
    }, [storeFolderSortInfo, data, mailAccountAliasMap]);
    const folderDragAble = useCallback((node) => {
        var _a;
        return !(((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) + '').startsWith('global');
    }, []);
    const handleFolderDrop = useCallback(e => {
        var _a, _b, _c;
        const { dragNode, node, dropToGap, dropPosition } = e;
        const nodeId = (_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId;
        const nodePid = ((_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.pid) || 0;
        const dragNodeId = (_c = dragNode === null || dragNode === void 0 ? void 0 : dragNode.entry) === null || _c === void 0 ? void 0 : _c.mailBoxId;
        if (nodeId !== dragNodeId) {
            let config = [...storeFolderSortInfo];
            const dragNodeConfig = config.find(item => item.id == dragNodeId);
            if (dragNodeConfig) {
                config = config.filter(item => item.id !== dragNodeId);
                if (dropPosition >= 0) {
                    const index = config.findIndex(item => item.id === nodeId);
                    config.splice(index + 1, 0, dragNodeConfig);
                }
                else {
                    const index = config.findIndex(item => item.id === nodeId);
                    config.splice(index, 0, dragNodeConfig);
                }
            }
            setStoreFolderSortInfo(config);
            trackApi.track('pcMail_merge_folderTree_sort', { folderId: dragNodeId, targetFolderId: nodeId, list: config });
        }
    }, [storeFolderSortInfo]);
    const handleFolderDropRef = useCreateCallbackForEvent(handleFolderDrop);
    const isCurTree = useMemo(() => {
        return folderIdIsAllFolder(selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.id);
    }, [selectedKeys]);
    const handleSwitchTab = useCallback((folder) => {
        var _a;
        let title = (_a = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName;
        const mailTabModel = {
            id: '-1',
            title,
            type: tabType.readMain,
            closeable: false,
            isActive: true,
            extra: {
                accountId: folder === null || folder === void 0 ? void 0 : folder._account,
            },
        };
        dispatch(mailTabActions.doSetTab(mailTabModel));
    }, []);
    const handleSwitchFolder = useCallback(debounce((node) => {
        if (node) {
            if (node.entry) {
                const { mailBoxId, mailBoxName } = node.entry;
                reducer.doSwitchFolder({
                    id: mailBoxId,
                    accountId: node === null || node === void 0 ? void 0 : node._account,
                    authAccountType: node === null || node === void 0 ? void 0 : node.authAccountType,
                });
            }
        }
    }, 300, {
        leading: true,
        trailing: true,
    }), []);
    const handleMultFolderSelect = useCallback((folder, accountTreeData) => {
        const fid = folder.entry.mailBoxId;
        try {
            accountApi.getMainAndSubAccounts({ expired: false }).then(accounts => {
                var _a;
                trackApi.track('pcMail_switch_folder_folderList', {
                    folderType: fid,
                    folderTypeName: '全部' + ((_a = folder === null || folder === void 0 ? void 0 : folder.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName),
                    agentNumber: accounts && accounts.length > 1 ? accounts.length - 1 : 0,
                });
            });
        }
        catch (e) {
            console.error(e);
        }
        handleSwitchFolder(folder);
        handleSwitchTab(folder);
    }, [handleSwitchFolder, handleSwitchTab]);
    const handleMultFolderSelectRef = useCreateCallbackForEvent(handleMultFolderSelect);
    const handleAllRead = (fid, account) => {
        trackApi.track('pcMail_click_topButton_mailListPage', { buttonName: '全标已读', folderId: fid, accountId: account });
        dispatch(reducer.updateAllReadLoading({
            accountId: account,
            folderId: fid,
            loading: true,
        }));
        return dispatch(Thunks.doActiveFolderAllRead({
            folderId: fid,
            isThread: isMerge(),
            accountId: account,
        }))
            .unwrap()
            .finally(() => {
            dispatch(reducer.updateAllReadLoading({
                accountId: account,
                folderId: fid,
                loading: false,
            }));
        });
    };
    const beforeHandleAllRead = (fid, account) => {
        SiriusModal.confirm({
            title: getIn18Text('markAllConfirm'),
            hideCancel: true,
            okText: getIn18Text('QUEREN'),
            okButtonProps: { danger: true, type: 'default' },
            onOk: () => {
                handleAllRead(fid, account);
            },
            onCancel: () => {
                return false;
            },
        });
    };
    const handleAllFollow = useCallback((fid, accountId) => {
        if (isAllFollowFolder(fid)) {
            return dispatch(Thunks.doActiveFolderAllFollow({
                isAll: true,
                customerEmail: isCustomerUnFollowFolder(fid),
            }));
        }
        else {
            if (parseAccountFromAllFolderSubAccount(fid)) {
                const account = parseAccountFromAllFolderSubAccount(fid);
                const resfid = parseAllFolderSubAccount(fid);
                return dispatch(Thunks.doActiveFolderAllFollow({
                    account: [account],
                    customerEmail: isCustomerUnFollowFolder(resfid),
                }));
            }
            else {
                return dispatch(Thunks.doActiveFolderAllFollow({
                    account: [selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.accountId],
                    customerEmail: isCustomerUnFollowFolder(fid),
                }));
            }
        }
    }, [isMerge]);
    const beforeHandleAllFollow = (fid, account) => {
        SiriusModal.confirm({
            title: isUnFollowFolder(fid) ? getIn18Text('SHIFOUJIANGSYWDDGJYJ5') : getIn18Text('SHIFOUJIANGSYYDDGJYJ5'),
            hideCancel: true,
            okText: getIn18Text('QUEREN'),
            okButtonProps: { danger: true, type: 'default' },
            onOk: () => {
                handleAllFollow(parseAllFolderSubAccount(fid), account);
            },
            onCancel: () => { },
        });
    };
    const allFolderMenu = useCreateCallbackForEvent((node) => {
        const shwoMap = {};
        storeFolderSortInfo === null || storeFolderSortInfo === void 0 ? void 0 : storeFolderSortInfo.forEach(item => {
            shwoMap[item.id] = item.show;
        });
        const folderData = dataRef.current || [];
        if (folderIdIsAllSentFolder(node.entry.mailBoxId) || folderIdIsAllDraftFolder(node.entry.mailBoxId)) {
            return (React.createElement(Menu, { className: styles.menu }, folderData
                .filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) != FLOLDER.ALL_RECEIVE; })
                .map(item => {
                var _a, _b;
                return (React.createElement(Menu.Item, { key: (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId, onClick: () => handleFodlerVisiableChange(item) },
                    React.createElement("div", { className: styles.menuItemWrap },
                        React.createElement("div", { className: styles.menuItem }, item === null || item === void 0 ? void 0 : item.entry.mailBoxName),
                        shwoMap[(_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId] ? (React.createElement("div", { className: styles.flag },
                            React.createElement(TongyongQueren, null))) : (React.createElement(React.Fragment, null)))));
            })));
        }
        return (React.createElement(Menu, { className: styles.menu },
            isFollowFolder(node.entry.mailBoxId) ? (React.createElement(Menu.Item, null,
                React.createElement("div", { className: styles.menuItemWrap, onClick: () => { var _a; return beforeHandleAllFollow((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId, node._account); } },
                    React.createElement("div", { className: styles.menuItem },
                        " ",
                        getIn18Text('QUANBIAOYIGJ'))))) : (React.createElement(Menu.Item, null,
                React.createElement("div", { className: styles.menuItemWrap, onClick: () => { var _a; return beforeHandleAllRead((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId, node._account); } },
                    React.createElement("div", { className: styles.menuItem }, getIn18Text('QUANBIAOYIDU'))))),
            React.createElement(Menu.SubMenu, { title: getIn18Text('XIANSHI1'), className: styles.menu }, folderData
                .filter(item => { var _a; return ((_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId) != FLOLDER.ALL_RECEIVE; })
                .map(item => {
                var _a, _b;
                return (React.createElement(Menu.Item, { key: (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxId, onClick: () => handleFodlerVisiableChange(item) },
                    React.createElement("div", { className: styles.menuItemWrap },
                        React.createElement("div", { className: styles.menuItem }, item === null || item === void 0 ? void 0 : item.entry.mailBoxName),
                        shwoMap[(_b = item === null || item === void 0 ? void 0 : item.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId] ? (React.createElement("div", { className: styles.flag },
                            React.createElement(TongyongQueren, null))) : (React.createElement(React.Fragment, null)))));
            }))));
    });
    return (React.createElement(FolderTree, { data: localData, dropdownClassName: styles.dropdown, expandedKeys: folderId2String(expandedKeys), onExpand: (keys, { node, expanded }) => {
            setExpandedKeys(keys);
        }, isMerge: false, editAble: true, selectedKey: folderTreeDragModel || curTabIsReadTab ? null : isCurTree ? selectedKeys.id : null, isOuterDrag: !!isDragModel, menu: allFolderMenu, onDrop: handleFolderDropRef, onSelect: handleMultFolderSelectRef, allowDrop: folderDragAble, draggable: folderDragAble, outerAllowDrop: false }));
};
export default AllFolder;
